import { gql } from "@apollo/client";

export const SEND_BUSINESS_CUSTOMER_LOGIN_CREDENTIAL = gql`
  mutation sendBusinessCustomerLoginCredential($businessCustomerId: ID!) {
    sendBusinessCustomerLoginCredential(businessCustomerId: $businessCustomerId) {
      success
      message
    }
  }
`;